// assets/ajax-cart.js
(function () {
  // Prevent double initialization
  if (window.__kwikCartInitialized) return;
  window.__kwikCartInitialized = true;
  
  // Element refs
  const els = {
    drawer: document.getElementById('kwik-cart-drawer'),
    overlay: document.getElementById('kwik-cart-overlay'),
    contents: document.getElementById('kwik-cart-contents'),
    subtotal: document.getElementById('kwik-cart-subtotal'),
    close: document.getElementById('kwik-cart-close'),
    count: document.getElementById('kwik-mini-cart-count'),
    totalEntries: document.getElementById('kwik-cart-total-entries'),
    subtotalEntries: document.querySelectorAll('.kwik-subtotal-entries'),
    multiplierEntries: document.querySelectorAll('.kwik-multiplier-entries'),
    multiplierWrapper: document.getElementById('kwik-multiplier-wrapper'),
    minicartCollections: document.getElementById('kwik-minicart-collections')
    };



  // Lightweight helpers for reading data-config from the DOM
  const readDataAttr = (elementId, attributeName, fallback = '') => {
    const el = document.getElementById(elementId);
    const val = el?.getAttribute(attributeName);
    return val || fallback;
  };

  const readNumberDataAttr = (elementId, attributeName, fallback = 0, minValue = -Infinity) => {
    const raw = readDataAttr(elementId, attributeName, '');
    const num = Number(raw);
    if (!Number.isFinite(num)) return fallback;
    return Math.max(minValue, num);
  };

  const KWIK_PRODUCT_HANDLE = readDataAttr('data-kwik-product-handle', 'data-kwik-product-handle', '');
  const KWIK_FREE_SHIPPING_TEXT = readDataAttr('data-kwik-freeShippingText', 'data-kwik-freeShippingText', '');
  const KWIK_SEE_WHAT_YOU_CAN_WIN_TEXT = readDataAttr('data-kwik-seeWhatYouCanWinText', 'data-kwik-seeWhatYouCanWinText', '');
  const KWIK_SEE_WHAT_YOU_CAN_WIN_LINK = readDataAttr('data-kwik-seeWhatYouCanWinLink', 'data-kwik-seeWhatYouCanWinLink', '');
  const KWIK_COLLECTION_TITLE = readDataAttr('data-kwik-collectionTitle', 'data-kwik-collectionTitle', '');
  const KWIK_COLLECTION_DESCRIPTION = readDataAttr('data-kwik-collectionDescription', 'data-kwik-collectionDescription', '');
  const KWIK_COLLECTION_IMAGE = readDataAttr('data-kwik-collectionImage', 'data-kwik-collectionImage', '');
  const KWIK_COLLECTION_LINK = readDataAttr('data-kwik-collectionLink', 'data-kwik-collectionLink', '');
  const KWIK_SHOW_COLLECTION = readDataAttr('data-kwik-showCollection', 'data-kwik-showCollection', '');
  const KWIK_ENTRIES_MULTIPLIER = readNumberDataAttr('data-kwik-entriesMultiplier', 'data-kwik-entriesMultiplier', 1, 0.01);


  const formatMoney = (cents) => {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(
        cents,
        "{{amount}}".replaceAll('&nbsp;', ' ')
      );
    }
    return (cents / 100).toFixed(2);
  };

  const formatNumber = (num) => {
    return num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  };

  // JSON fetch helper
  const fetchJSON = (url, opts = {}) =>
    fetch(
      url,
      Object.assign(
        { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } },
        opts
      )
    ).then(async (r) => {
      if (!r.ok) throw { status: r.status, data: await r.json().catch(() => ({})) };
      return r.json();
    });

  // Mini-cart count updater
  const updateCount = (count) => {
    if (!els.count) return;
    els.count.textContent = count;
    els.count.hidden = count === 0;
    els.count.setAttribute('aria-hidden', count === 0 ? 'true' : 'false');
  };

  // Drawer controls
  const openCart = () => {
    if (!els.drawer || !els.overlay) return;
    els.drawer.hidden = false;
    els.overlay.hidden = false;
    els.drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  };
  const closeCart = () => {
    if (!els.drawer || !els.overlay) return;
    els.drawer.hidden = true;
    els.overlay.hidden = true;
    els.drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  };

  // Shopify cart endpoints
  const getCart = () => fetchJSON('/cart.js');
 
  // Helper to check if a cart is empty
  const isCartEmpty = (cart) => ((cart?.item_count ?? 0) === 0) || !(cart?.items?.length);

  const addToCart = async (form) => {
    const fd = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw err;
    }
    return getCart();
  };

  const changeLine = (key, quantity) =>
    fetchJSON('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity) || 0) }),
    });

  const clearCart = () => fetchJSON('/cart/clear.js', { method: 'POST' });

  // Free shipping progress
  const domCfg = document.getElementById('kwik-config');
  const FREE_SHIPPING_THRESHOLD = (() => {
    const val = domCfg?.getAttribute('data-free-shipping');
    const num = Number(val);
    return Number.isFinite(num) ? num * 100 : 1000 * 100;
  })();

  const domCfgTagNumber = document.getElementById('data-kwik-tag-number');
  const KWIK_TAG_NUMBER = (() => {
    const num = readNumberDataAttr('data-kwik-tag-number', 'data-kwik-tag-number', 1, 1);
    return Number.isFinite(num) ? num : 1;
  })();

  const updateFreeShippingProgress = (cart) => {
    const wrap = document.getElementById('kwik-cart-progress');
    const bar = document.getElementById('kwik-cart-progress-bar');
    const fill = document.getElementById('kwik-cart-progress-fill');
    const remainingEl = document.getElementById('kwik-cart-progress-remaining');
    const unlockedEl = document.getElementById('kwik-cart-progress-unlocked');
    const labelEl = document.getElementById('kwik-cart-progress-label');
    if (!wrap || !bar || !fill || !remainingEl || !unlockedEl || !labelEl) return;

    const subtotal = cart?.items_subtotal_price ?? 0;
    const pct = Math.max(0, Math.min(100, Math.floor((subtotal / FREE_SHIPPING_THRESHOLD) * 100)));

    bar.setAttribute('aria-valuenow', String(pct));
    fill.style.width = pct + '%';

    if (subtotal >= FREE_SHIPPING_THRESHOLD) {
      wrap.classList.add('unlocked');
      unlockedEl.hidden = false;
      remainingEl.textContent = '';
      labelEl.textContent = `You’ve unlocked ${KWIK_FREE_SHIPPING_TEXT}`;
    } else {
      wrap.classList.remove('unlocked');
      unlockedEl.hidden = true;
      const remaining = FREE_SHIPPING_THRESHOLD - subtotal;
      remainingEl.textContent = formatMoney(remaining);
      labelEl.textContent = `You are ${formatMoney(remaining)} away from ${KWIK_FREE_SHIPPING_TEXT}!`;
    }
  };

  // --- Product tag cache + fetcher ---
  const productTagCache = {};
  const getProductTags = async (handle) => {
    if (productTagCache[handle]) return productTagCache[handle];
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return [];
      const product = await res.json();
      const raw = product.tags || [];
      const tagArray = Array.isArray(raw)
        ? raw
        : String(raw)
            .split(',')
            .map((t) => t.trim())
            .filter(Boolean);
      productTagCache[handle] = tagArray;
      return productTagCache[handle];
    } catch (e) {
      console.error('Could not fetch tags for', handle, e);
      return [];
    }
  };

  // Render cart contents with tags
  const renderCart = async (cart) => {
    if (els.subtotal) els.subtotal.textContent = formatMoney(cart.items_subtotal_price);

    // Handle multiplier wrapper and collections visibility
    if (els.multiplierWrapper) {
      els.multiplierWrapper.style.display = cart.items.length ? 'block' : 'none';
    }
    
    // Handle minicart collections visibility
    if (els.minicartCollections) {
      els.minicartCollections.style.display = cart.items.length ? 'none' : 'block';
    }

    if (cart.items.length === 0) {
      document.querySelector('.kwik-total-entries strong').textContent = '0 Entries';
    }

    updateCount(cart.item_count);
    updateFreeShippingProgress(cart);
    els.isEmpty = isCartEmpty(cart);

    const totalLabel = document.querySelector('.kwik-cart-total span');
    if (totalLabel) {
      totalLabel.textContent = `Subtotal (${cart.item_count} ${cart.item_count === 1 ? 'Item' : 'Items'})`;
    }

    if (!els.contents) return;

    if (!cart.items.length) {
      if (KWIK_SHOW_COLLECTION === 'true') {
        els.contents.innerHTML = `
          <div class="kwik-cart-line">

          <a href="${KWIK_COLLECTION_LINK}" target="_blank"><img src="${KWIK_COLLECTION_IMAGE}" alt=""></a>
          <div class="kwik-cart-title-wrapper">
            <div class="kwik-cart-line-title"><a href="${KWIK_COLLECTION_LINK}" target="_blank">${KWIK_COLLECTION_TITLE}</a></div>
            <div class="kwik-cart-line-entries">${KWIK_COLLECTION_DESCRIPTION}</div>
          </div>
        </div>
        `;
      } else {
        els.contents.innerHTML = `<p class="kwik-empty-cart-message">Your cart is empty.</p>`;
      }
      updateFreeShippingProgress(cart);
      return;
    }

    const lineResults = await Promise.all(cart.items.map(async (item) => {
      const tags = await getProductTags(item.handle);
      const hasKwikTag = tags.some((t) => typeof t === 'string' && t.toLowerCase().includes('kwik'));
      const kwikNumbers = tags
        .map((t) => {
          const str = String(t).toLowerCase();
          const m = str.match(/kwik\s*(\d+)/);
          return m ? m[1] : null;
        })
        .filter(Boolean);
      const kwikValue = kwikNumbers[0] || 1;

      const props = item.properties
        ? Object.entries(item.properties)
            .filter(([k, v]) => v !== null && v !== '')
            .map(([k, v]) => `<div>${k}: ${v}</div>`)
            .join('')
        : '';
      const sellingPlan = item.selling_plan_allocation?.selling_plan?.name
        ? `<div>${item.selling_plan_allocation.selling_plan.name}</div>`
        : '';
      const linePriceDollars = Math.floor(Number(item.final_line_price) / 100) || 0;
      let lineEntries;

      if (KWIK_PRODUCT_HANDLE && item.handle === KWIK_PRODUCT_HANDLE) {
        lineEntries = 0;
      } else {
        lineEntries = Number(kwikValue) > 0 ? linePriceDollars * KWIK_ENTRIES_MULTIPLIER * Number(kwikValue) : linePriceDollars;
      }

      const html = `
        <div class="kwik-cart-line" data-key="${item.key}" data-has-kwik="${hasKwikTag ? 'true' : 'false'}" data-kwik-num="${kwikValue}">
          <img src="${(item.image || '').replace(
            /(\.jpe?g|\.png|\.webp)(\?.*)?$/i,
            '_100x$1'
          )}" alt="">
          <div class="kwik-cart-title-wrapper">
            <div class="kwik-cart-line-title">${item.product_title}</div>
            ${KWIK_PRODUCT_HANDLE !== item.handle ? `<div class="kwik-cart-line-entries">${formatNumber(lineEntries)} Entries <br> <strong>${ kwikValue }X Entries</strong></div>` : `<div class="kwik-cart-line-entries">${KWIK_TAG_NUMBER}X Entries</div>`}
            <div class="kwik-see-what-you-can-win"><a href="${KWIK_SEE_WHAT_YOU_CAN_WIN_LINK}" target="_blank">${KWIK_SEE_WHAT_YOU_CAN_WIN_TEXT}</a></div>
          </div>
          <div class="kwik-line-remove" aria-label="Remove"><svg width="20px" height="20px" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.8489 22.6922C11.5862 22.7201 11.3509 22.5283 11.3232 22.2638L10.4668 14.0733C10.4392 13.8089 10.6297 13.5719 10.8924 13.5441L11.368 13.4937C11.6307 13.4659 11.8661 13.6577 11.8937 13.9221L12.7501 22.1126C12.7778 22.3771 12.5873 22.614 12.3246 22.6418L11.8489 22.6922Z" fill="#000000"></path><path d="M16.1533 22.6418C15.8906 22.614 15.7001 22.3771 15.7277 22.1126L16.5841 13.9221C16.6118 13.6577 16.8471 13.4659 17.1098 13.4937L17.5854 13.5441C17.8481 13.5719 18.0387 13.8089 18.011 14.0733L17.1546 22.2638C17.127 22.5283 16.8916 22.7201 16.6289 22.6922L16.1533 22.6418Z" fill="#000000"></path><path clip-rule="evenodd" d="M11.9233 1C11.3494 1 10.8306 1.34435 10.6045 1.87545L9.54244 4.37037H4.91304C3.8565 4.37037 3 5.23264 3 6.2963V8.7037C3 9.68523 3.72934 10.4953 4.67218 10.6145L7.62934 26.2259C7.71876 26.676 8.11133 27 8.56729 27H20.3507C20.8242 27 21.2264 26.6513 21.2966 26.1799L23.4467 10.5956C24.3313 10.4262 25 9.64356 25 8.7037V6.2963C25 5.23264 24.1435 4.37037 23.087 4.37037H18.4561L17.394 1.87545C17.1679 1.34435 16.6492 1 16.0752 1H11.9233ZM16.3747 4.37037L16.0083 3.50956C15.8576 3.15549 15.5117 2.92593 15.1291 2.92593H12.8694C12.4868 2.92593 12.141 3.15549 11.9902 3.50956L11.6238 4.37037H16.3747ZM21.4694 11.0516C21.5028 10.8108 21.3154 10.5961 21.0723 10.5967L7.1143 10.6285C6.86411 10.6291 6.67585 10.8566 6.72212 11.1025L9.19806 24.259C9.28701 24.7317 9.69985 25.0741 10.1808 25.0741H18.6559C19.1552 25.0741 19.578 24.7058 19.6465 24.2113L21.4694 11.0516ZM22.1304 8.7037C22.6587 8.7037 23.087 8.27257 23.087 7.74074V7.25926C23.087 6.72743 22.6587 6.2963 22.1304 6.2963H5.86957C5.34129 6.2963 4.91304 6.72743 4.91304 7.25926V7.74074C4.91304 8.27257 5.34129 8.7037 5.86956 8.7037H22.1304Z" fill="#000000" fill-rule="evenodd"></path></svg> </div>
        </div>
        <div class="kwik-qty-price" data-key="${item.key}">
        ${KWIK_PRODUCT_HANDLE !== item.handle ? `
          <div class="kwik-qty" aria-label="Quantity">
            <button class="kwik-qty-button kwik-qty-dec" aria-label="Decrease quantity">−</button>
            <input class="kwik-qty-input" type="number" min="0" step="1" value="${item.quantity}">
            <button class="kwik-qty-button kwik-qty-inc" aria-label="Increase quantity">+</button>
          </div>
          ` : ''}
          <div class="kwik-cart-line-meta">
            <div>${formatMoney(item.final_line_price)}</div>
          </div>
        </div>
      `;
      return { html, entries: lineEntries };
    }));

    els.contents.innerHTML = lineResults.map((r) => r.html).join('');

    let insideCart = false;
    cart.items.forEach((item) => {
      if (item.handle === KWIK_PRODUCT_HANDLE) {
        insideCart = true;
      }
    });
    
    // Hide/show upsell product based on whether kwik product is in cart
    const upsellProduct = document.querySelector('.kwik-upsell-product');
    if (upsellProduct) {
      upsellProduct.style.display = insideCart ? 'none' : 'grid';
    }
    
    // Update total entries in footer
    const totalEntriesValue = lineResults.reduce((sum, r) => sum + (Number(r.entries) || 0), 0);
    const totalEntriesEl = els.totalEntries || document.querySelector('.kwik-total-entries strong');
    if (totalEntriesEl) {
      totalEntriesEl.textContent = insideCart
        ? `${formatNumber(totalEntriesValue * KWIK_TAG_NUMBER)} Entries`
        : `${formatNumber(totalEntriesValue)} Entries`;
    }

    if (els.subtotalEntries) {
      els.subtotalEntries.forEach((el) => {
        el.textContent = `${formatNumber(totalEntriesValue)}`;
      });
    }
    if (els.multiplierEntries) {
      els.multiplierEntries.forEach((el) => {
        el.textContent = `${formatNumber(totalEntriesValue * KWIK_TAG_NUMBER)}`;
      });
    }
  };

  // Click events
  const onDocumentClick = (e) => {
    // Handle add-to-cart button clicks directly to prevent double submission
    const addToCartBtn = e.target.closest('button[type="submit"], input[type="submit"], [name="add"]');
    if (addToCartBtn) {
      const form = addToCartBtn.closest('form[data-ajax], form[action*="/cart/add"]');
      if (form && form.dataset.kwikSubmitting === 'true') {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    }
    
    const openBtn = e.target.closest('[data-open-cart]');
    if (openBtn) {
      e.preventDefault();
      getCart().then((cart) => {
        renderCart(cart);
        openCart();
      });
      return;
    }

    const clickedClose = e.target.closest('#kwik-cart-close');
    const clickedOverlay = e.target === els.overlay;
    if (clickedClose || clickedOverlay) {
      closeCart();
      return;
    }

    const removeBtn = e.target.closest('.kwik-line-remove');
    if (removeBtn) {
      const line = e.target.closest('.kwik-cart-line');
      const key = line?.dataset?.key;
      if (!key) return;
      removeBtn.disabled = true;
      changeLine(key, 0)
        .then(renderCart)
        .catch(alert)
        .finally(() => (removeBtn.disabled = false));
      return;
    }

    const dec = e.target.closest('.kwik-qty-dec');
    const inc = e.target.closest('.kwik-qty-inc');
    if (dec || inc) {
      const container = e.target.closest('[data-key]');
      const key = container?.dataset?.key;
      if (!key) return;
      const input = container.querySelector('.kwik-qty-input');
      const next = Math.max(0, (Number(input.value) || 0) + (inc ? 1 : -1));
      
      // Disable all quantity controls during update
      const qtyControls = container.querySelectorAll('.kwik-qty-button, .kwik-qty-input');
      qtyControls.forEach(control => control.disabled = true);
      
      input.value = next;
      changeLine(key, next)
        .then(renderCart)
        .catch((err) => {
          alert(err?.description || 'Could not update quantity');
        })
        .finally(() => {
          // Re-enable controls after operation completes
          qtyControls.forEach(control => control.disabled = false);
        });
      return;
    }
  };

  // Debounced manual qty typing
  let qtyTimer = null;
  const onInput = (e) => {
    const input = e.target.closest('.kwik-qty-input');
    if (!input) return;
    const container = input.closest('[data-key]');
    const key = container?.dataset?.key;
    if (!key) return;
    
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(() => {
      // Disable all quantity controls during update
      const qtyControls = container.querySelectorAll('.kwik-qty-button, .kwik-qty-input');
      qtyControls.forEach(control => control.disabled = true);
      
      changeLine(key, input.value)
        .then(renderCart)
        .catch((err) => {
          alert(err?.description || 'Could not update quantity');
        })
        .finally(() => {
          // Re-enable controls after operation completes
          qtyControls.forEach(control => control.disabled = false);
        });
    }, 350);
  };

  // AJAX add-to-cart
  const onSubmit = (e) => {
    // Check if this is a form submission we should handle
    const form = e.target.closest('form[data-ajax], form[action*="/cart/add"]');
    if (!form) return;
    
    // Prevent double submission
    if (form.dataset.kwikSubmitting === 'true') {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }
    
    // Mark form as submitting immediately
    form.dataset.kwikSubmitting = 'true';
    
    // Prevent default and stop all propagation
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    const submitter = form.querySelector('[type="submit"]');
    const originalText = submitter?.textContent;
    if (submitter) {
      submitter.disabled = true;
      submitter.style.pointerEvents = 'none';
      submitter.style.opacity = '0.6';
    }

    addToCart(form)
      .then((cart) => {
        renderCart(cart);
        openCart();
      })
      .catch((err) => {
        alert(err?.description || 'Could not add to cart');
      })
      .finally(() => {
        delete form.dataset.kwikSubmitting;
        if (submitter) {
          submitter.disabled = false;
          submitter.style.pointerEvents = '';
          submitter.style.opacity = '';
          if (originalText) submitter.textContent = originalText;
        }
      });
    
    return false;
  };

  // Global fetch hook
  (() => {
    const _fetch = window.fetch;
    let isProcessingCartUpdate = false;
    window.fetch = async (...args) => {
      const res = await _fetch(...args);
      try {
        const [input, init] = args;
        const url = typeof input === 'string' ? input : input?.url || '';
        const method = (init?.method || 'GET').toUpperCase();
        if (method !== 'GET' && /\/cart\/(add|change|update|clear)\.js(\?|$)/.test(url)) {
          // Prevent duplicate processing
          if (isProcessingCartUpdate) {
            return res;
          }
          isProcessingCartUpdate = true;
          
          // Wait a bit to ensure the cart update is complete
          setTimeout(() => {
            getCart()
              .then((cart) => {
                updateCount(cart.item_count);
                updateFreeShippingProgress(cart);
                // Update multiplier wrapper and collections visibility
                if (els.multiplierWrapper) {
                  els.multiplierWrapper.style.display = cart.items.length ? 'block' : 'none';
                }
                if (els.minicartCollections) {
                  els.minicartCollections.style.display = cart.items.length ? 'none' : 'block';
                }
                if (!els.drawer?.hidden) renderCart(cart);
                else updateFreeShippingProgress(cart);
              })
              .catch(() => {})
              .finally(() => {
                isProcessingCartUpdate = false;
              });
          }, 100);
        }
      } catch (_) {}
      return res;
    };
  })();

  // Init listeners
  document.addEventListener('click', onDocumentClick);
  document.addEventListener('input', onInput);
  // Use capture phase to intercept form submissions early
  document.addEventListener('submit', onSubmit, true);

  // Initial badge
  getCart()
    .then((cart) => {
      updateCount(cart.item_count);
      // Set initial multiplier wrapper and collections visibility
      if (els.multiplierWrapper) {
        els.multiplierWrapper.style.display = cart.items.length ? 'block' : 'none';
      }
      if (els.minicartCollections) {
        els.minicartCollections.style.display = cart.items.length ? 'none' : 'block';
      }
    })
    .catch(() => {});
})();